/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./NewAttendUser.vue?vue&type=template&id=4bfebb8c&scoped=true&"
import script from "./NewAttendUser.vue?vue&type=script&lang=js&"
export * from "./NewAttendUser.vue?vue&type=script&lang=js&"
import style0 from "./NewAttendUser.vue?vue&type=style&index=0&id=4bfebb8c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfebb8c",
  null
  
)

export default component.exports